import { Injectable } from '@angular/core';
import { HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Tokens } from '../model/tokens/tokens';
import { AuthToken } from '../model/tokens/auth-token';
import { HttpService } from '../http/http.service';

@Injectable()
export class HttpAuthService {
  private readonly REFRESH_TOKEN_URI: string = '/refreshtoken';
  private readonly PRINCIPAL: string = '/';

  constructor(private httpService: HttpService) {}

  public refreshToken(): Observable<HttpEvent<Tokens>> {
    // Appel au serveur pour l'authentification
    // L'http-interceptor s'occupe d'injecter le refresh Token à la place du jeton jwt
    return this.httpService.get<Tokens>(this.REFRESH_TOKEN_URI);
  }
  /**
   * Stocke le jeton JWT dans le localStorage
   * @param authToken - jeton JWT v2
   */
  private setSession(authToken: AuthToken): void {
    localStorage.setItem('auth-token', authToken.token);
  }

  /**
   * Retire le jeton JWT du localStorage, coupant ainsi
   * l'accès de l'utilisateur à sa session serveur v2
   */
  public logout(): void {
    localStorage.removeItem('auth-token');
  }

  public getToken(): AuthToken | void {
    const token = localStorage.getItem('auth-token');
    if (token) {
      const authToken: AuthToken = { token };
      return authToken;
    }
  }
}
